import script from "./ExamTimetablePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamTimetablePage.vue?vue&type=script&setup=true&lang=js"

import "./ExamTimetablePage.vue?vue&type=style&index=0&id=746bbab2&lang=css"

const __exports__ = script;

export default __exports__